import React from 'react'
import { useSelector } from 'react-redux'
import { BUTTON_LOADING_VARIANTS } from 'constants/uiConfig'
import ButtonLoadingV1 from './ButtonLoadingV1'
import ButtonLoadingV2 from './ButtonLoadingV2'

// Orchestrator for ButtonLoading variants. Defaults to V1.
const ButtonLoading = () => {
  const general = useSelector(state => state?.uiConfig?.general)
  const variant = general?.buttonLoadingVariant ?? BUTTON_LOADING_VARIANTS.V1

  if (variant === BUTTON_LOADING_VARIANTS.V2) {
    return <ButtonLoadingV2 />
  }

  return <ButtonLoadingV1 />
}

export default ButtonLoading
